/*
 * title-fit.js
 *
 * Les grands titres (police NTSeawave) sont affichés à une taille fixe définie
 * en CSS. Quand un titre contient un mot trop long pour sa colonne
 * (ex. « L'ŒNOTHÈQUE » sur mobile), le navigateur le coupait au milieu du mot,
 * à un endroit variable selon la largeur d'écran.
 *
 * Le CSS interdit désormais toute coupure à l'intérieur d'un mot. Ce script
 * réduit la taille du titre — et uniquement de ceux qui débordent — juste ce
 * qu'il faut pour qu'il tienne dans sa colonne. Les titres qui tiennent déjà
 * gardent la taille définie dans le CSS.
 */

(function () {
  var SELECTOR = [
    '.title-center .container-xl h2',
    '.title-center-with-video .container-xl h2',
    '.product-text-video .content h2',
    '.product-text-media .content h2',
    '.product-two-media .center h2',
  ].join(',');

  // On ne descend jamais sous 60 % de la taille prévue par le CSS.
  var MIN_SCALE = 0.6;

  function availableWidth(el) {
    var parent = el.parentElement;
    if (!parent) return 0;
    var styles = window.getComputedStyle(parent);
    return (
      parent.clientWidth -
      (parseFloat(styles.paddingLeft) || 0) -
      (parseFloat(styles.paddingRight) || 0)
    );
  }

  function fit(el) {
    // On repart toujours de la taille CSS (indispensable au redimensionnement).
    el.style.fontSize = '';

    var base = parseFloat(window.getComputedStyle(el).fontSize);
    var available = availableWidth(el);
    if (!base || available <= 0) return;

    var needed = el.scrollWidth;
    if (needed <= available + 1) return; // le titre tient : on ne touche à rien

    var size = Math.max(base * MIN_SCALE, Math.floor(base * (available / needed)));
    el.style.fontSize = size + 'px';

    // Le rapport largeur/taille n'est pas parfaitement linéaire (crénage,
    // arrondis) : quelques passes suffisent à converger.
    for (var i = 0; i < 4 && el.scrollWidth > available + 1; i++) {
      size -= 1;
      if (size < base * MIN_SCALE) break;
      el.style.fontSize = size + 'px';
    }
  }

  function fitAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var titles = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < titles.length; i++) fit(titles[i]);
  }

  var scheduled = false;
  function scheduleFitAll() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      fitAll();
    });
  }

  function init() {
    fitAll();
    // Les polices custom se chargent après le premier rendu : on remesure.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitAll();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', scheduleFitAll);
  window.addEventListener('orientationchange', scheduleFitAll);

  // Éditeur de thème : une section rechargée doit être remesurée.
  document.addEventListener('shopify:section:load', function (event) {
    fitAll(event.target);
  });
})();
